import React from 'react';
import { Dialog, Text, Pane, Flex, List, Toast } from '@leverege/ui-elements';
import { LoadingView } from '@leverege/molten/views';
import S from './ConvertLocatorToGateway.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class ConvertLocatorToGateway extends React.Component {
  onOkay = async () => {
    const {
      onClose,
      locationId,
      targets,
      reloadData,
      dispatch,
      systemId
    } = this.props;
    const locatorIds = targets.map(target => target.id);
    const closeLoading = LoadingView.showDialog('Initiating Conversion');
    try {
      await dispatch(async (dispatch, getState, {
        api
      }) => api.system(systemId).srv('recovr').post('bulkConvertLocatorToGateway', {
        locatorIds,
        locationId
      }));
      await reloadData();
      Toast.success('Conversion Initiated');
    } catch (e) {
      console.error(e);
      Toast.error([e.message || 'Error converting locators']);
    }
    onClose();
    closeLoading();
  };
  onCancel = () => {
    const {
      onClose
    } = this.props;
    onClose();
  };
  render() {
    const {
      show,
      onClose,
      targets
    } = this.props;
    return /*#__PURE__*/_jsx(Dialog.Question, {
      show: show,
      onClose: onClose,
      icon: "fa fa-wrench",
      title: "Convert Locators to Gateways",
      okay: "Convert Locators",
      okayVariant: "primary",
      cancelVariant: "secondary",
      onOkay: this.onOkay,
      okayDisabled: !targets,
      onCancel: this.onCancel,
      children: /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colM",
        children: [/*#__PURE__*/_jsxs(Text, {
          children: ["This will initiate the conversion process on these locators:", /*#__PURE__*/_jsx(List, {
            children: targets.map(target => {
              return /*#__PURE__*/_jsx(Text, {
                className: S.locatorList,
                children: target?.data?.name
              }, target.data?.name);
            })
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          children: " "
        })]
      })
    });
  }
}